<template>
    <section
        class="content-component content-component-tabs row justify-content-center"
        data-component="tabComponent">
        <div class="col-12 tabs-component">
            <ul :class="'nav nav-tabs tabs-component-tabs component-id-' + id" role="tablist">
                <li v-for="item in items"
                    class="nav-item tabs-component-tab"
                    role="presentation">
                    <a class="nav-link tab-component-link"
                       :class="{ 'active': isActive(item) }"
                       :id="'nav-' + item.anchor + '-' + id"
                       :href="'#' + item.anchor + '-' + id"
                       :aria-controls="item.anchor"
                       :aria-selected="isActive(item)"
                       @click.prevent="selectItem(item)"
                       :data-caption="item.title">
                        {{ item.title }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="tab-content col-12">
            <div
                role="tabpanel"
                class="active tab-pane"
                v-if="currentItem"
            >
                <component
                    v-if="alreadyLoaded(currentItem)"
                    :is="'tab-content-' + currentItem.id"
                />
                <div
                    v-else
                    class="d-flex loader"
                >
                    <div class="spinner-border text-primary m-auto" role="status">
                        <span class="sr-only">{{ __('Loading...') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'TabComponent',
    props: {
        id: {
            type: Number,
            required: true
        },

        items: {
            required: true,
            type: Array,
        },

        locale: {
            type: String,
            default: 'hu'
        }
    },

    created() {
        this.setDefaultItem()
        this.loadContent()
    },

    data() {
        return {
            currentItem: null,
            currentContent: null,
            components: {}
        }
    },

    methods: {
        setDefaultItem() {
            const defaultFromHash = this.getDefaultFromHash()

            if (defaultFromHash) {
                this.currentItem = defaultFromHash
                return
            }

            const defaultItem = this.items.find(item => item.is_default)

            this.currentItem = ! defaultItem && this.items.length >= 1
                ? this.items[0]
                : defaultItem
        },

        getDefaultFromHash() {
            if (! window.location.hash) {
                return null
            }

            const anchor = window.location.hash.slice(1);

            const split = anchor.split('-')

            if (split.length < 2) {
                return null
            }

            if (split[1] != this.id) {
                return null
            }

            return this.items.find(item => item.anchor === split[0])
        },

        isActive(item) {
            return item === this.currentItem
        },

        selectItem(item) {
            this.currentItem = item
            const href = '#' + item.anchor + '-' + this.id

            window.history.pushState({}, '', window.location.pathname + href)

            this.loadContent()
        },

        async loadContent() {
            if (! this.currentItem) {
                return
            }

            if (this.alreadyLoaded(this.currentItem)) {
                return
            }

            try {
                const response = await axios.get(`${this.locale}/api/tab-component-item-content/${this.currentItem.id}`)

                this.registerDynamicComponent(response.data)
                this.currentContent = response.data
            } catch (exception) {
                console.error(exception)
            }
        },

        alreadyLoaded(item) {
            return typeof this.$options.components['tab-content-' + item.id] !== 'undefined'
        },

        registerDynamicComponent(data) {
            const compiled = Vue.compile(data)
            const name = 'tab-content-' + this.currentItem.id

            this.$options.components[name] = Vue.component(name, {
                name: 'TabContent' + this.currentItem.id,
                mounted: () => fitvids('.content-component'),
                render: compiled.render,
                staticRenderFns: compiled.staticRenderFns
            })

            this.$forceUpdate()
        }
    }
}
</script>

<style scoped>
    .loader {
        min-height: 300px;
    }
</style>
